'use client'

import { useState } from 'react'

import { EyeClosed, Eye } from 'lucide-react'
import { useFormContext } from 'react-hook-form'

import { useAuthContext } from '@/features/auth/contexts/AuthContext'
import { FormItem } from '@/shared/form/FormItem'
import { Input } from '@/shared/form/Input'

import { validationSchema } from './validationSchema'

interface SignInFieldsProps {
  inputClassName?: string
  emailRef?: React.RefObject<HTMLInputElement>
  passwordRef?: React.RefObject<HTMLInputElement>
}

export const SignInFields = ({
  inputClassName,
  emailRef,
  passwordRef
}: SignInFieldsProps) => {
  const { goToForgotPassword, config } = useAuthContext()
  const { getValues } = useFormContext()
  const [seePassword, setSeePassword] = useState(false)

  const signInLoginLabel = config?.signIn?.loginLabel ?? 'Login'
  const hideForgotPassword = !!config?.signIn?.hideForgotPasswordAction

  return (
    <>
      <FormItem name="login" vertical>
        <FormItem.Label>{signInLoginLabel}</FormItem.Label>
        <FormItem.Control>
          <Input
            name="login"
            autoComplete="username"
            className={inputClassName}
            ref={emailRef}
          />
        </FormItem.Control>
      </FormItem>

      <FormItem name="password" vertical>
        <FormItem.Label className="fw-bolder flex justify-between">
          Senha
          {!hideForgotPassword ? (
            <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold">
              <a
                href="#"
                className="text-sm font-medium text-brand-cyan hover:opacity-75"
                onClick={event => {
                  event.preventDefault()
                  goToForgotPassword({ email: getValues('login') })
                }}
              >
                Esqueceu a senha?
              </a>
            </div>
          ) : null}
        </FormItem.Label>

        <div className="relative">
          <FormItem.Control>
            <Input
              name="password"
              type={seePassword ? 'text' : 'password'}
              autoComplete="current-password"
              className={inputClassName}
              ref={passwordRef}
            />
          </FormItem.Control>
          <button
            type="button"
            className="absolute right-0 top-1/2 flex -translate-y-1/2 items-center gap-x-1 pr-3"
            onClick={() => setSeePassword(!seePassword)}
          >
            {seePassword ? (
              <Eye className="h-4 w-4 text-gray-500" />
            ) : (
              <EyeClosed className="h-4 w-4 text-gray-500" />
            )}
          </button>
        </div>
      </FormItem>
    </>
  )
}

SignInFields.validationSchema = validationSchema
